export default "__VITE_ASSET__DPLEq_o8__"